export const autocomplete = [{
  "id":3,
  "name":"Abu Dhabi",
  "externalID":"6020" 
},
{
  "id":399,
  "name":"Shams Abu Dhabi",
  "externalID":"7766"
},
{
  "id":3490,
  "name":"Najmat Abu Dhabi",
  "externalID":"6698"
},
{
  "id":458,
  "name":"Danet Abu Dhabi",
  "externalID":"6858"
},
{
  "id":4995,
  "name":"Rawdhat Abu Dhabi",
  "externalID":"9771"
},
{
  "id":4982,
  "name":"Abu Dhabi Gate City (Officers City)",
  "externalID":"7137"
},
{
  "id":946,
  "name":"ICAD - Industrial City Abu Dhabi",
  "externalID":"9714"
},
{
  "id":15948,
  "name":"Abu Dhabi National Exhibition Centre ADNEC",
  "externalID":"12114"
},
{
  "id":502,
  "name":"Hills Abu Dhabi",
  "externalID":"7875"
},
{
  "id":17784,
  "name":"Dusit Thani Abu Dhabi",
  "externalID":"13556"
}
]